import React from 'react';
import { Modal, Input, Form, Select, Divider } from 'antd';

import { RUC, DNI } from '../../../common/types/tipoDocumentoType';
import { JURIFICA, NATURAL } from '../../../common/types/tipoPersonaType';
import { DOMICILIO_FISCAL } from '../../../common/types/tipoEstablecimientoType';
import { HABIDO } from '../../../common/types/condicionSunatType';
import { ACTIVO } from '../../../common/types/estadoContribuyenteType';
import { FORMAT_EMAIL } from '../../../common/types/regularExpresionType';

const { Option } = Select;
const { Search } = Input;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleChangeTipoPersona = (option, item) => {  
        this.props.form.setFieldsValue({
            flagPersonaJuridica: item.props.data === JURIFICA.CODIGO ? true : false,
            flagPersonaNatural: item.props.data === NATURAL.CODIGO ? true : false,
            idTipoDocumento: undefined,
            numeroDocumento: '',
            razonSocial: '',
            nombre: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            idCondicionSunat: { key: HABIDO },
            idEstadoContribuyente: { key: ACTIVO },
            idDepartamento: undefined,
            idProvincia: undefined,
            idUbigeo: undefined,
            direccion: '',
        }, () => {
            this.props.onChange("clear");
        });
    }

    numeroDocumentoCustomValidation = (rule, value, callback) => {
        var idTipoDocumento = this.props.form.getFieldValue('idTipoDocumento').key;
        var numeroDocumentoLongitud = this.props.form.getFieldValue('numeroDocumento').length;
        var longitud = idTipoDocumento === RUC.ID ? 11 : 8;

        if ([RUC.ID, DNI.ID].includes(idTipoDocumento) &&
            numeroDocumentoLongitud !== longitud &&
            numeroDocumentoLongitud > 0)
            callback('La longitud de ser de ' + longitud + ' caracteres.');

        callback();
    }

    correoCustomValidation = (rule, value, callback) => {
        var regexp = new RegExp(FORMAT_EMAIL);
        if (value !== null && value.length > 0 && !regexp.test(value))
            callback('Formato de correo invalido.');
            
        callback();
    }

    imputHidden = (rule, value) => {
        if (value !== undefined) {
            if (value.key == 3 || value.key == 5 || value.key == 1) {
                return true;
            } else {
                return false;
            }
        }
    }

    imputOtros = (rule, value) => {
        if (value !== undefined) {
            if (value.key == 1) {
                return true;
            } else {
                return false;
            }
        }
    }
    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    idTipoPersona: values.idTipoPersona.key,
                    idTipoDocumento: values.idTipoDocumento.key,
                    numeroDocumento: values.numeroDocumento,
                    razonSocial: values.razonSocial,
                    nombre: values.nombre,
                    apellidoPaterno: values.apellidoPaterno,
                    apellidoMaterno: values.apellidoMaterno,
                    idCondicionSunat: values.idCondicionSunat.key,
                    idEstadoContribuyente: values.idEstadoContribuyente.key,
                    idTipoRelacion: values.idTipoRelacion === undefined ? 0 : values.idTipoRelacion.key,
                    idPais: values.idPais === undefined ? 0 : values.idPais.key,
                    correo: values.correo,
                    contacto:values.contacto,
                    //diasVencimiento: values.diasVencimiento,
                    idTipoEstablecimiento: DOMICILIO_FISCAL.ID,
                    idUbigeo: values.idUbigeo === undefined ? 0 : values.idUbigeo.key,
                    telefono: values.telefono,
                    direccion: values.direccion,

                };
                this.props.onSave(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('flagPersonaJuridica', { initialValue: this.props.formValues.flagPersonaJuridica });
        getFieldDecorator('flagPersonaNatural', { initialValue: this.props.formValues.flagPersonaNatural });

        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Proveedor" : "Modificar Proveedor"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
                width="800px"
            >
                <Form>
                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Tipo de Persona">
                                {getFieldDecorator('idTipoPersona', {
                                    initialValue: this.props.formValues.idTipoPersona ? { key: this.props.formValues.idTipoPersona } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.'
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Tipo de Persona"}
                                        optionFilterProp="children"
                                        onChange={this.handleChangeTipoPersona}
                                    >
                                        {this.props.formValues.tiposPersona.map(item => (
                                            <Option key={item.id} value={item.id} data={item.codigo}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Tipo de Documento">
                                {getFieldDecorator('idTipoDocumento', {
                                    initialValue: this.props.formValues.idTipoDocumento ?
                                        { key: this.props.formValues.idTipoDocumento } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.'
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Tipo de Documento"}
                                        optionFilterProp="children"
                                        onChange={this.handleChangeTipoDocumento}
                                    >
                                        {
                                            (this.props.form.getFieldValue('flagPersonaJuridica') ?
                                                this.props.formValues.tiposDocumento.filter(m => m.id === RUC.ID) :
                                                this.props.form.getFieldValue('flagPersonaNatural') ? this.props.formValues.tiposDocumento.filter(m => m.id === DNI.ID) : 
                                                this.props.formValues.tiposDocumento.filter(m => m.id !== RUC.ID && m.id !== DNI.ID))
                                                .map(item => (
                                                    <Option key={item.id} value={item.id} data={item.codigo}>{item.abreviatura}</Option>
                                                ))
                                        }
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Número Documento">
                                {getFieldDecorator('numeroDocumento', {
                                    initialValue: this.props.formValues.numeroDocumento,
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Campo obligatorio.',
                                            whitespace: true,
                                        },
                                        {
                                            validator: this.numeroDocumentoCustomValidation
                                        }
                                    ]
                                })(
                                    <Search
                                        placeholder="Búsqueda por Documento"
                                        autoComplete="off"
                                        maxLength={20}
                                        loading={this.props.formValues.searchLoading}
                                        onSearch={value => this.props.onBuscarPadronReducido(this.props.form.getFieldValue('idTipoDocumento').key, value, this.props.form)}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row" style={{ display: this.props.form.getFieldValue('flagPersonaJuridica') ? "" : "none" }}>
                        <div className="col-md-12 form-group">
                            <Form.Item label="Razón Social">
                                {getFieldDecorator('razonSocial', {
                                    initialValue: this.props.formValues.razonSocial,
                                    rules: [{
                                        required: this.props.form.getFieldValue('flagPersonaJuridica'),
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Razón Social"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row" style={{ display: !this.props.form.getFieldValue('flagPersonaJuridica') ? "" : "none" }}>
                        <div className="col-md-12 form-group">
                            <Form.Item label="Nombre">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre,
                                    rules: [{
                                        required: !this.props.form.getFieldValue('flagPersonaJuridica'),
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row" style={{ display: !this.props.form.getFieldValue('flagPersonaJuridica') ? "" : "none" }}>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Apellido Paterno">
                                {getFieldDecorator('apellidoPaterno', {
                                    initialValue: this.props.formValues.apellidoPaterno,
                                    rules: [{
                                        required:false,// !this.props.form.getFieldValue('flagPersonaJuridica'),
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Apellido Paterno"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Apellido Materno">
                                {getFieldDecorator('apellidoMaterno', {
                                    initialValue: this.props.formValues.apellidoMaterno,
                                    rules: [{
                                        required:false,// !this.props.form.getFieldValue('flagPersonaJuridica'),
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Apellido Materno"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 form-group" hidden={!this.props.form.getFieldValue('flagPersonaJuridica')}>
                            <Form.Item label="Condición Sunat">
                                {getFieldDecorator('idCondicionSunat', {
                                    initialValue: this.props.formValues.idCondicionSunat ?
                                        { key: this.props.formValues.idCondicionSunat } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Condición Sunat"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.condicionesSunat.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group" hidden={!this.props.form.getFieldValue('flagPersonaJuridica')}>
                            <Form.Item label="Estado Contribuyente">
                                {getFieldDecorator('idEstadoContribuyente', {
                                    initialValue: this.props.formValues.idEstadoContribuyente ?
                                        { key: this.props.formValues.idEstadoContribuyente } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Estado Contribuyente"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.estadosContribuyente.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Tipo de Relación">
                                {getFieldDecorator('idTipoRelacion', {
                                    initialValue: this.props.formValues.idTipoRelacion ? { key: this.props.formValues.idTipoRelacion } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Tipo de Relación"}
                                        optionFilterProp="children"
                                    >
                                        <Option key={0} value={0}>
                                            <span style={{ color: '#bfbfbf' }}>Ninguno</span>
                                        </Option>
                                        {this.props.formValues.tiposRelacion.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Correo">
                                {getFieldDecorator('correo', {
                                    initialValue: this.props.formValues.correo,
                                    rules: [
                                        {
                                            validator: this.correoCustomValidation
                                        }
                                    ]
                                })(
                                    <Input
                                        placeholder="Ingresar Correo"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-6 form-group">
                            <Form.Item label="Contacto">
                                {getFieldDecorator('contacto', {
                                    initialValue: this.props.formValues.contacto
                                })(
                                    <Input
                                        placeholder="Ingresar contacto"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                    <div className="col-md-6 form-group" style={{ display: this.props.form.getFieldValue('flagPersonaJuridica') ? "none" : this.props.form.getFieldValue('flagPersonaNatural') ? "none" : "" }}>
                            <Form.Item label="Pais">
                                {getFieldDecorator('idPais', {
                                    initialValue: this.props.formValues.idPais ?
                                        { key: this.props.formValues.idPais } : undefined,
                                        rules: [{
                                            required: this.props.form.getFieldValue('flagPersonaJuridica') ? false : this.props.form.getFieldValue('flagPersonaNatural') ? false : true,
                                            message: 'Campo obligatorio.'
                                        }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione país"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.paises.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    
                    <div className="row" style={{ marginTop: '10px' }}>
                        <div className="col-md-12 form-group">
                            <span style={{ fontWeight: '500' }}>Datos de Dirección</span>
                        </div>
                    </div>
                    <Divider style={{ marginTop: '0px' }} />

                    <div className="row">
                    <div className="col-md-6 form-group" hidden={this.imputHidden(0, this.props.form.getFieldValue('idTipoDocumento'))}>
                            <Form.Item label="Tipo Establecimiento">
                                {getFieldDecorator('nombreTipoEstablecimiento', {
                                    initialValue: this.props.formValues.nombreTipoEstablecimiento
                                })(
                                    <Input disabled autoComplete="off" />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Teléfono">
                                {getFieldDecorator('telefono', {
                                    initialValue: this.props.formValues.telefono,
                                })(
                                    <Input
                                        placeholder="Ingresar Teléfono"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                    <div className="col-md-4 form-group" hidden={this.imputHidden(0, this.props.form.getFieldValue('idTipoDocumento'))}>
                            <Form.Item label="Departamento">
                                {getFieldDecorator('idDepartamento', {
                                    initialValue: this.props.formValues.idDepartamento ?
                                        { key: this.props.formValues.idDepartamento } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione departamento"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ idProvincia: undefined });
                                            this.props.form.setFieldsValue({ idUbigeo: undefined });
                                            this.props.onChange("idDepartamento", option.key)
                                        }}
                                    >
                                        {this.props.formValues.departamentos.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group" hidden={this.imputHidden(0, this.props.form.getFieldValue('idTipoDocumento'))}>
                            <Form.Item label="Provincia">
                                {getFieldDecorator('idProvincia', {
                                    initialValue: this.props.formValues.idProvincia ?
                                        { key: this.props.formValues.idProvincia } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione provincia"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ idUbigeo: undefined });
                                            this.props.onChange("idProvincia", option.key)
                                        }}
                                    >
                                        {this.props.formValues.provincias.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group" hidden={this.imputHidden(0, this.props.form.getFieldValue('idTipoDocumento'))}>
                            <Form.Item label="Distrito">
                                {getFieldDecorator('idUbigeo', {
                                    initialValue: this.props.formValues.idUbigeo ?
                                        { key: this.props.formValues.idUbigeo } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione distrito"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.distritos.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Dirección">
                                {getFieldDecorator('direccion', {
                                    initialValue: this.props.formValues.direccion
                                })(
                                    <Input
                                        placeholder="Ingresar Dirección"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)